import { NavLink } from 'react-router-dom';
import './BottomTabBar.css';

export function BottomTabBar() {
  return (
    <nav className="bottom-tab-bar" aria-label="Main navigation">
      <NavLink to="/" className="bottom-tab-bar__item" end>
        <svg
          className="bottom-tab-bar__icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M3 12l9-9 9 9" />
          <path d="M5 10v9a1 1 0 001 1h4v-5h4v5h4a1 1 0 001-1v-9" />
        </svg>
        <span className="bottom-tab-bar__label">Home</span>
      </NavLink>

      <NavLink to="/thc-drinks" className="bottom-tab-bar__item">
        <svg
          className="bottom-tab-bar__icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <circle cx="11" cy="11" r="7" />
          <path d="M21 21l-4.35-4.35" />
        </svg>
        <span className="bottom-tab-bar__label">Search</span>
      </NavLink>

      <NavLink to="/thc-drinks?mode=review" className="bottom-tab-bar__item">
        <svg
          className="bottom-tab-bar__icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M12 20h9" />
          <path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z" />
        </svg>
        <span className="bottom-tab-bar__label">Review</span>
      </NavLink>

      <NavLink to="/thc-drinks?buyable=true" className="bottom-tab-bar__item bottom-tab-bar__item--buy">
        <svg
          className="bottom-tab-bar__icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <circle cx="9" cy="21" r="1" />
          <circle cx="20" cy="21" r="1" />
          <path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6" />
        </svg>
        <span className="bottom-tab-bar__label">Buy</span>
      </NavLink>

      <NavLink to="/stash" className="bottom-tab-bar__item">
        <svg
          className="bottom-tab-bar__icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <circle cx="12" cy="8" r="4" />
          <path d="M4 20c0-4 4-7 8-7s8 3 8 7" />
        </svg>
        <span className="bottom-tab-bar__label">My Stash</span>
      </NavLink>
    </nav>
  );
}
